import { memo } from "react";

const NoteCustomDisplay = ({ value }) => {
  return <div className="whitespace-pre-wrap ">{value ?? ""}</div>;
};

export default memo(NoteCustomDisplay);
